import terms from './terms-agencies-2026-10-26.json';
import privacy from './privacy-policy-2026-10-26.json';

export const TERMS_VERSION = terms.version;
export const PRIVACY_VERSION = privacy.version;
export const TERMS_PATH = '/condizioni-agenzie';
export const PRIVACY_PATH = '/privacy-policy';
export const LEGAL_DOCUMENTS = { terms, privacy };

export function getLegalDocument(kind, version) {
    const current = LEGAL_DOCUMENTS[kind];
    return !version || version === current?.version ? current : null;
}

export function documentText(document) {
    return [document.title, `Versione: ${document.version}`, `Aggiornamento: ${document.updatedAt}`,
        ...document.sections.flatMap(section => [section.title, ...section.paragraphs])].join('\n\n') + '\n';
}

export function downloadLegalDocument(document, name = document === terms ? 'condizioni-agenzie' : 'privacy') {
    const url = URL.createObjectURL(new Blob([documentText(document)], { type: 'text/plain;charset=utf-8' }));
    const link = window.document.createElement('a');
    link.href = url;
    link.download = `easy-funeral-${name}-${document.version}.txt`;
    window.document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
